<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card>
      <v-card-title class="mx-3">
        {{
          combine
            ? $t("Material.Fields.combine_formula")
            : split
            ? $t("Material.Fields.split_formula")
            : ""
        }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-progress-linear :indeterminate="loading"></v-progress-linear>
      <v-card-text>
        <v-snackbar
          v-model="snackbar"
          color="error"
          timeout="6000"
          text
          top
          absolute
        >
          {{ $t("Material.productionAttributes.formulaUndone") }}
          <template v-slot:action="{ attrs }">
            <v-icon
              dark
              class="mx-2"
              v-bind="attrs"
              color="error"
              @click="snackbar = false"
              >fa-times
            </v-icon>
          </template>
        </v-snackbar>
        <v-tabs v-model="currentTab" center-active show-arrows>
          <v-tab>
            {{ formula.name }}
          </v-tab>
        </v-tabs>
        <v-sheet class="pa-3" v-if="formula">
          <v-row>
            <v-text-field
              v-model="formula.name"
              :label="$t('Material.productionAttributes.formulaName')"
            >
            </v-text-field>
            <v-spacer />
            <v-switch
              v-model="formula.default_flg"
              :label="$t('Material.productionAttributes.formulaDefault')"
            />
          </v-row>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    {{
                      combine
                        ? $t("Material.productionAttributes.combineMaterial")
                        : split
                        ? $t("Material.productionAttributes.splitMaterial")
                        : ""
                    }}
                    <span v-if="combine" style="background: #00ff00">
                      （{{
                        $t("ProductionPlans.DetailFields.combined_material")
                      }}）
                    </span>
                    <span v-else style="background: #ffff00">
                      （{{
                        $t("ProductionPlans.DetailFields.split_material")
                      }}）
                    </span>
                  </th>
                  <th class="text-center">
                    {{ $t("Material.productionAttributes.rate") }}
                  </th>
                  <th class="text-center">
                    {{ $t("Material.productionAttributes.formulaMaterial") }}
                    <span v-if="combine" style="background: #ffff00">
                      （{{
                        $t("ProductionPlans.DetailFields.split_material")
                      }}）
                    </span>
                    <span v-else style="background: #00ff00">
                      （{{
                        $t("ProductionPlans.DetailFields.combined_material")
                      }}）
                    </span>
                  </th>
                  <th class="text-center">
                    {{ $t("Material.productionAttributes.rate") }}
                  </th>
                  <th class="text-center">
                    {{ $t("TableHeaders.actions") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in formula.formula_details" :key="i">
                  <td class="text-center">
                    {{ i == 0 ? materialName : "" }}
                  </td>
                  <td class="text-center">
                    {{ i == 0 ? "1 " + defaultUnit : "" }}
                  </td>
                  <td class="text-center">
                    {{
                      $t(
                        settings
                          ? settings.material_name_display_type == 4
                            ? "Material.nameWithCodeAndStandard"
                            : settings.material_name_display_type == 3
                            ? "Material.materialNameWithCodeAndStandard"
                            : settings.material_name_display_type == 2
                            ? "Material.materialNameWithCode"
                            : "Material.materialName"
                          : "Material.materialName",
                        [
                          item.material_code,
                          item.material_name,
                          item.standard_name,
                        ]
                      )
                    }}
                  </td>
                  <td class="text-center">
                    <v-text-field
                      v-model="item.ratio"
                      type="number"
                      min="0.01"
                      single-line
                      dense
                      hide-details
                      style="
                        max-width: 80px;
                        margin-left: auto;
                        margin-right: auto;
                      "
                      :suffix="item.unit"
                    />
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      color="accent"
                      @click.stop="formula.formula_details.splice(i, 1)"
                      >fa-times
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td class="text-center" colspan="4">
                    <SearcherMaterial
                      v-model="addMaterial"
                      :disabled-items="
                        formula.formula_details.map((detail) => {
                          return { id: detail.material_id };
                        })
                      "
                      no-label
                      dense
                      unclearable
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            dialog = false;
            $emit('confirm', formula);
          "
        >
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import Materials from "@/api/materials";

export default {
  name: "Formula",

  props: {
    value: Object,
    materialName: String,
    defaultUnit: String,
    show: Boolean,
    combine: Boolean,
    split: Boolean,
  },

  components: {
    SearcherMaterial,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    snackbar: false,
    dialog: false,
    formula: {},
    currentTab: 0,
    currentFormula: null,
    idx: 1,
    addMaterial: null,
  }),

  mounted() {},

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.currentTab = 0;
        this.idx = 1;
        if (this.value) {
          this.formula = JSON.parse(
            //确保创建新拷贝而不是指向引用
            JSON.stringify(this.value)
          );
          return;
        }
        this.formula = {};
      },
    },
    show: {
      handler() {
        this.dialog = this.show;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) this.$emit("close", this.dialog);
      },
    },
    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.id) {
          Materials.fetchOne(this.addMaterial.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                var material = response.data.material;
                this.formula.formula_details.push({
                  material_id: material.id,
                  material_code: material.material_code,
                  material_name: material.material_name,
                  standard_name: material.standard.name,
                  standard_detail_id:
                    material.standard.default_standard_detail.id,
                  unit: material.standard.default_standard_detail.unit,
                });
              }
            }.bind(this)
          );
          this.addMaterial = { id: 0, material_code: "", material_name: "" }; //消除显示
        }
      },
    },
  },

  methods: {},
};
</script>
